<template>
  <fragment>
    <div class="item" ref="item">
      <!-- <app-sa-editor> -->
      <div class="item-cont" :id="`sa-editor-${id}`">
        <!-- <editor-tool> -->
        <div class="wrap-tool-bar">
          <ul class="tool-bar ml-2 clearfix">
            <!-- app-copy -->
            <div placement="right" data-title="复制" class="tool-block mr-2">
              <li
                class="d-inline-block"
                @click="copy"
                @mousedown="copyMousedownMenu"
                @mouseleave="copyMouseleaveMenu"
              >
                <i class="iconfont"></i>
                <small></small>
              </li>
            </div>
            <!-- app-cut -->
            <div placement="right" data-title="剪切" class="tool-block mr-2">
              <li
                class="d-inline-block"
                @click="cut"
                @mousedown="cutMousedownMenu"
                @mouseleave="cutMouseleaveMenu"
              >
                <i class="iconfont"></i>
                <small></small>
              </li>
            </div>
            <!-- app-paste -->
            <div placement="right" data-title="粘贴" class="tool-block mr-2">
              <li
                class="d-inline-block"
                @click="paste"
                @mousedown="pasteMousedownMenu"
                @mouseleave="pasteMouseleaveMenu"
              >
                <i class="iconfont"></i>
              </li>
            </div>
            <!-- editor-formula -->
            <div
              placement="right"
              data-title="插入公式符号"
              class="tool-block mr-2"
            >
              <li
                class="d-inline-block tool-formula"
                @mousedown="formulaMousedownMenu"
                @mouseup="formulaMouseupMenu"
                @mouseenter="formulaMouseenterMenu"
                @mouseleave="formulaMouseleaveMenu"
              >
                <span>
                  <i class="iconfont"></i>
                  <small></small>
                </span>
                <div class="wra-nav-tabs" v-if="showMenu">
                  <ul ngbnav class="nav-tabs nav" role="tablist">
                    <li class="nav-item">
                      <a
                        href="#ngb-nav-9-panel"
                        ngbnavlink
                        id="ngb-nav-9"
                        role="tab"
                        data-toggle="tab"
                        aria-controls="ngb-nav-9-panel"
                        aria-selected="true"
                        aria-disabled="false"
                        class="nav-link active"
                      >
                        <small>常用公式</small>
                      </a>
                      <!---->
                    </li>
                    <li class="nav-item">
                      <a
                        href="#ngb-nav-10-panel"
                        ngbnavlink
                        id="ngb-nav-10"
                        role="tab"
                        data-toggle="tab"
                        aria-controls="ngb-nav-10-panel"
                        aria-selected="false"
                        aria-disabled="false"
                        class="nav-link"
                      >
                        <small>符号</small>
                      </a>
                      <!---->
                    </li>
                    <li class="nav-item">
                      <a
                        href="#ngb-nav-11-panel"
                        ngbnavlink
                        id="ngb-nav-11"
                        role="tab"
                        data-toggle="tab"
                        aria-controls="ngb-nav-11-panel"
                        aria-selected="false"
                        aria-disabled="false"
                        class="nav-link"
                      >
                        <small>希腊字母</small>
                      </a>
                      <!---->
                    </li>
                  </ul>
                  <div class="mt-2 tab-content">
                    <div
                      ngbnavpane
                      class="tab-pane fade show active"
                      id="ngb-nav-9-panel"
                      role="tabpanel"
                      aria-labelledby="ngb-nav-9"
                    >
                      <ul class="formular-list text-left formular-fc">
                        <li
                          class="fc1"
                          title="分数"
                          @click="insertLatex('\\frac{} {}', 0)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc2"
                          title="斜角分数"
                          @click="insertLatex('^{}/_{}', 1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc3"
                          title="上标"
                          @click="insertLatex('x^{}', 0)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc4"
                          title="下标"
                          @click="insertLatex('x_{}', 0)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc5"
                          title="上标和下标"
                          @click="insertLatex('x_{n}^{n}', 1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc6"
                          title="顶线符号"
                          @click="insertLatex('\\bar{}', 1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc7"
                          title="平方根符号"
                          @click="insertLatex('\\sqrt{}', 0)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc8"
                          title="3次求根符号"
                          @click="insertLatex('\\nthroot3{}', 1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc9"
                          title="求根符号"
                          @click="insertLatex('\\sqrt[]{}', 0)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc10"
                          title="上下都有标签的求和符号"
                          @click="insertLatex('\\sum^{}_{n=}', 0)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc12"
                          title="对数"
                          @click="insertLatex('\\log_{}\\left(\\right)', 3)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fc13"
                          title="自然对数"
                          @click="insertLatex('\\ln\\left(\\right)', 1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                      </ul>
                      <!---->
                    </div>
                    <div
                      ngbnavpane
                      class="tab-pane fade"
                      id="ngb-nav-10-panel"
                      role="tabpanel"
                      aria-labelledby="ngb-nav-10"
                    >
                      <ul class="formular-list text-left formular-fa">
                        <li
                          class="fa1"
                          title="加号"
                          @click="insertLatex('+', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa2"
                          title="减号"
                          @click="insertLatex('-', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa3"
                          title="加减号"
                          @click="insertLatex('\\pm', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa4"
                          title="乘号"
                          @click="insertLatex('\\times', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa5"
                          title="星号"
                          @click="insertLatex('\\ast', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa6"
                          title="除号"
                          @click="insertLatex('\\div', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa7"
                          title="斜杠"
                          @click="insertLatex('/', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa8"
                          title="无穷大"
                          @click="insertLatex('\\infty', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa9"
                          title="偏微分"
                          @click="insertLatex('\\partial', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa10"
                          title="增量"
                          @click="insertLatex('\\bigtriangleup', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa11"
                          title="等号"
                          @click="insertLatex('=', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa12"
                          title="不等于"
                          @click="insertLatex('\\ne', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa13"
                          title="几乎等于"
                          @click="insertLatex('\\approx', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa14"
                          title="大于号"
                          @click="insertLatex('>', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa15"
                          title="小于号"
                          @click="insertLatex('<', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa16"
                          title="大于或等于"
                          @click="insertLatex('\\ge', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa17"
                          title="小于或等于"
                          @click="insertLatex('\\le', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa18"
                          title="连乘"
                          @click="insertLatex('\\prod_{ }^{ }', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa19"
                          title="积分"
                          @click="insertLatex('\\int_{ }^{ }', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          class="fa20"
                          title="箭头"
                          @click="insertLatex('\\rightarrow', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                      </ul>
                      <!---->
                    </div>
                    <div
                      ngbnavpane
                      class="tab-pane fade"
                      id="ngb-nav-11-panel"
                      role="tabpanel"
                      aria-labelledby="ngb-nav-11"
                    >
                      <ul class="formular-list text-left formular-fb">
                        <li
                          title="Alpha"
                          class="fb1"
                          @click="insertLatex('\\alpha', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Beta"
                          class="fb2"
                          @click="insertLatex('\\beta', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Gamma"
                          class="fb3"
                          @click="insertLatex('\\gamma', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Delta"
                          class="fb4"
                          @click="insertLatex('\\delta', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Epsilon"
                          class="fb5"
                          @click="insertLatex('\\epsilon', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Phi"
                          class="fb6"
                          @click="insertLatex('\\phi', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Lambda"
                          class="fb7"
                          @click="insertLatex('\\lambda', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Mu"
                          class="fb8"
                          @click="insertLatex('\\mu', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Rho"
                          class="fb9"
                          @click="insertLatex('\\rho', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Sigma"
                          class="fb10"
                          @click="insertLatex('\\sigma', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Omega"
                          class="fb11"
                          @click="insertLatex('\\omega', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Xi"
                          class="fb12"
                          @click="insertLatex('\\xi', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Theta"
                          class="fb13"
                          @click="insertLatex('\\theta', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Phi"
                          class="fb14"
                          @click="insertLatex('\\Phi', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Sigma"
                          class="fb15"
                          @click="insertLatex('\\Sigma', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                        <li
                          title="Gamma"
                          class="fb16"
                          @click="insertLatex('\\Gamma', !1)"
                        >
                          <span>&nbsp;</span>
                        </li>
                      </ul>
                      <!---->
                    </div>
                    <!---->
                    <!---->
                    <!---->
                    <!---->
                  </div>
                </div>
              </li>
            </div>
            <!-- editor-table -->
            <div
              placement="right"
              data-title="插入表格矩阵"
              class="tool-block d-inline-block mr-2"
            >
              <li
                class="wrap-tab-li d-inline-block tool-table"
                @mousedown="tableMousedownMenu"
                @mouseup="tableMouseupMenu"
                @mouseenter="tableMouseenterMenu"
                @mouseleave="tableMouseleaveMenu"
              >
                <span>
                  <i class="iconfont"></i>
                  <small></small>
                </span>
                <div class="wrap-tab-cont" v-if="showTabList">
                  <ul class="matrix-list">
                    <li class="d-inline-block mr-3" @click="creatCusMatrix(2)">
                      <small>2*2矩阵</small>
                    </li>
                    <li class="d-inline-block" @click="creatCusMatrix(3)">
                      <small>3*3矩阵</small>
                    </li>
                  </ul>
                  <div class="wrap-tab">
                    <ul class="tab-list clearfix mt-2">
                      <li :key="`idxr-${idxr}`" v-for="idxr in rowTableArr">
                        <span
                          :class="
                            idxr < maxRow && idxc < maxColume ? 'active' : ''
                          "
                          @mousemove="customTab(idxc, idxr)"
                          @click="creatCusTab"
                          :key="`idxc-${idxc}`"
                          v-for="idxc in colTableArr"
                        ></span>
                      </li>
                    </ul>
                    <div class="custom-tab mt-2 mb-2">
                      <small class>行：</small>
                      <span class="pl-2 pr-2">{{ maxRow }}</span
                      >&nbsp;
                      <small class>列：</small>
                      <span class="pl-2 pr-2">{{ maxColume }}</span>
                      <!---->
                      <!---->
                    </div>
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </div>
        <!-- </editor-tool> -->
        <div
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
          spellcheck="false"
          x-palm-disable-ste-all="true"
          :contenteditable="!disabled"
          class="without-answer answer-area"
          id="item-answer"
          style="height: 146px"
          @input="changeAnswerEmit"
          @blur="handleBlur"
          ref="answerArea"
        ></div>
      </div>
      <ul class="editor-context-menu math-matrix-menu">
        <li>删除当前矩阵</li>
        <li>删除当前行</li>
        <li>删除当前列</li>
      </ul>
      <ul class="editor-context-menu table-menu">
        <li>
          插入
          <i class="arrow-rt iconfont float-right"></i>
          <ul class="sub-menu-insert sub-table-menu">
            <li @click="insert('rowAbove')">行 (在上方)</li>
            <li @click="insert('rowBelow')">行 (在下方)</li>
            <li @click="insert('columnLt')">列 (在左侧)</li>
            <li @click="insert('columnRt')">列 (在右侧)</li>
          </ul>
        </li>
        <li @click="removeCurEntity">删除当前表格</li>
        <li @click="removeCurRow">删除当前行</li>
        <li @click="removeCurColume">删除当前列</li>
      </ul>
      <!-- </app-sa-editor> -->
    </div>
  </fragment>
</template>
<script>
import $ from 'jquery';
import Swal from 'sweetalert2';

export default {
  name: 'sa-editor',

  props: {
    value: {
      type: String,
      default: () => '',
    },

    disabled: {
      type: Boolean,
      default: () => false,
    },

    id: {
      type: String,
      default: () => '' + new Date().getTime(),
    },
  },

  data: () => {
    return {
      editorStatus: {
        inEditor: !1,
        inTable: !1,
        inMatrix: !1,
        inFormula: !1,
        inToolbar: !1,
        inMathMatrix: !1,
      },

      curEntityIdDeleted: '',
      curEntityIdTd: '',
      curFormulaId: '',

      menuType: '',

      showMenu: false,
      timerHide: null,

      showTabList: !1,
      maxColume: 1,
      maxRow: 1,
      autoMode: !0,
      rowTableArr: [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
        //
        10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        //
        20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
      ],
      colTableArr: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],

      isToolBarIconClicked: false,
      flagBlur: true,

      prevValue: '',
    };
  },

  watch: {
    value(v) {
      if (this.prevValue !== v) {
        this.setAnswerAreaHtml();
      }
    },
  },

  methods: {
    clearCurFormulaId() {
      this.curFormulaId = '';
    },

    resetToolVal() {
      (this.editorStatus = {
        inEditor: !1,
        inTable: !1,
        inMatrix: !1,
        inFormula: !1,
        inToolbar: !1,
        inMathMatrix: !1,
      }),
        (this.curFormulaId = '');
      const t =
        (document.hasFocus() &&
          document.activeElement !== document.body &&
          document.activeElement !== document.documentElement &&
          document.activeElement) ||
        null;
      t && t instanceof HTMLElement && this.updateEditorStatus(t);
    },

    updateEditorStatus(t) {
      if (this.editorStatus && this.editorStatus.inToolbar) return;
      const e = JSON.parse(JSON.stringify(this.editorStatus));
      let n = !1,
        i = !1,
        r = !1,
        s = !1,
        o = !1,
        a = !1;
      for (t.tagName || (t = t.parentElement); 'BODY' != t.tagName; ) {
        if (window.$(t).parents('.mq-editable-field').length) {
          (a = !0),
            (n = !0),
            (this.curFormulaId = window
              .$(t)
              .parents('.mq-editable-field')
              .attr('id'));
          break;
        }
        if (t.id.indexOf('insert-matrix') >= 0) {
          (s = !0), (n = !0), this.clearCurFormulaId();
          break;
        }
        if (t.id.indexOf('insert-math-matrix') >= 0) {
          (o = !0), (n = !0), this.clearCurFormulaId();
          break;
        }
        if (t.id.indexOf('insert-tab') >= 0) {
          (i = !0), (n = !0), this.clearCurFormulaId();
          break;
        }
        if (t.className.indexOf('tool-bar') >= 0) {
          (r = !0), (n = !0);
          break;
        }
        if (
          t.isContentEditable ||
          'true' == t.getAttribute('contenteditable')
        ) {
          (n = !0), this.clearCurFormulaId();
          break;
        }
        t = t.parentElement;
      }
      (this.editorStatus = r
        ? e
        : {
            inEditor: n,
            inTable: i,
            inMatrix: s,
            inFormula: a,
            inToolbar: r,
            inMathMatrix: o,
          }),
        this.isInEditor || this.clearCurFormulaId();
    },

    getCurFocusEle(t) {
      this.updateEditorStatus(t.srcElement ? t.srcElement : t.target);
    },

    isInEditor() {
      return this.editorStatus.inEditor;
    },

    hideContextMenu() {
      const t = this.getMenuByType();
      t && (t.style.display = 'none');
    },

    itemContDomFocused(t) {
      if (
        /* !this.hasInitAnswer() &&  */ (this.getCurFocusEle(t),
        this.isInEditor())
      ) {
        let e = t.target;
        for (; e; ) {
          if (e.classList.contains('answer-area')) {
            e.classList.add('active');
            break;
          }
          e = e.parentElement;
        }
      }
    },

    itemContDomBlur(t) {
      //if (this.hasInitAnswer())
      //    return;
      this.resetToolVal();
      let e = t.target;
      for (; e; ) {
        if (e.classList.contains('answer-area')) {
          e.classList.remove('active');
          break;
        }
        e = e.parentElement;
      }
    },

    initContextmenu(t) {
      t.preventDefault();
      const e = t.srcElement ? t.srcElement : t.target,
        n = window.$(e).closest('td[data-menu-id]');
      if (!n.data('menu-id')) return;
      (this.curEntityIdDeleted = n.data('menu-id')), (this.curEntityIdTd = n);
      const i = t.pageX,
        r = t.pageY;
      this.menuType = n.data('menu-type');
      const s = this.getMenuByType();
      (s.style.left = i + 5 + 'px'),
        (s.style.top = r + 5 + 'px'),
        (s.style.display = 'block');
    },

    setAnswerHg() {
      //if (!this.hasInitAnswer() && this.subItem && "tab" == this.item.content.sub_items_layout) {
      //    const t = document.querySelector(".item-answer-area")
      //      , e = document.querySelector(".subitem .item-head")
      //      , n = document.querySelector(".item-cont .answer-area")
      //      , i = document.querySelector("editor-tool .wrap-tool-bar");
      //    n && t && e && i && (n.style.height = t.clientHeight - e.offsetHeight - i.offsetHeight - 20 + "px")
      //}
    },

    execCommand(t, e, n) {
      try {
        document.execCommand(t, e, n)
          ? document.execCommand(t, e, n)
          : console.log(
              "\u6d4f\u89c8\u5668\u4e0d\u652f\u6301\uff1adocument.execCommand('" +
                t +
                "',false, null)"
            );
      } catch (i) {
        console.log(
          "\u6d4f\u89c8\u5668\u6267\u884c\u62a5\u9519\uff1adocument.execCommand('" +
            t +
            "',false, null)"
        );
      }
    },

    insertTextAtCursor(t) {
      if (window.getSelection) {
        const e = window.getSelection();
        if (e.getRangeAt && e.rangeCount) {
          let n = e.getRangeAt(0);
          n.deleteContents();
          let i = document.createElement('div');
          i.innerHTML = t;
          let r,
            s,
            o = document.createDocumentFragment();
          for (; (r = i.firstChild); ) s = o.appendChild(r);
          n.insertNode(o),
            s &&
              ((n = n.cloneRange()),
              n.setStartAfter(s),
              n.collapse(!1),
              e.removeAllRanges(),
              e.addRange(n));
        }
      } else
        document.selection &&
          document.selection.createRange &&
          (document.selection.createRange().text = t);
    },

    parseStringToDom(t) {
      return new DOMParser().parseFromString(t, 'text/html').body.children[0];
    },

    insertHtmlAtCursor(t, e, n) {
      if (window.getSelection) {
        const i = window.getSelection();
        if (i.getRangeAt && i.rangeCount) {
          const r = i.getRangeAt(0);
          r.deleteContents();
          let s = t;
          if (e) {
            const i = document.createElement(e);
            n && i.setAttribute('id', n), (i.innerHTML = t), (s = i);
          } else s = this.parseStringToDom(t);
          if (n && n.indexOf('formula') > -1) {
            const t = document.createElement('span'),
              e = document.createTextNode('\xa0');
            s.classList.add('insert-formula'),
              t.appendChild(s),
              t.appendChild(e),
              r.insertNode(t);
          } else r.insertNode(s);
        }
      } else
        document.selection &&
          document.selection.createRange &&
          document.selection.createRange().createContextualFragment(t);
    },

    _toolBarIconMousedownMenu(t) {
      $(t.target).parents('.tool-block').addClass('ofClicked');
      this.isToolBarIconClicked = true;
    },

    copy() {
      if (this.disabled) return false;
      this.execCommand('copy', !1, null);
    },

    copyMousedownMenu(t) {
      if (this.disabled) return false;
      this._toolBarIconMousedownMenu(t);
      return (this.editorStatus.inToolbar = !0);
    },

    copyMouseleaveMenu(t) {
      $(t.target).parents('.tool-block').removeClass('ofClicked');
      return (this.editorStatus.inToolbar = !1);
    },

    cut() {
      if (this.disabled) return false;
      this.execCommand('cut', !1, null);
    },

    cutMousedownMenu(t) {
      if (this.disabled) return false;
      this._toolBarIconMousedownMenu(t);
      return (this.editorStatus.inToolbar = !0);
    },

    cutMouseleaveMenu(t) {
      $(t.target).parents('.tool-block').removeClass('ofClicked');
      return (this.editorStatus.inToolbar = !1);
    },

    paste() {
      if (this.disabled) return false;
      if (this.editorStatus.inEditor) {
        if (navigator.clipboard)
          return navigator.clipboard
            .readText()
            .then((t) => {
              this.insertTextAtCursor(t),
                //this.pasted.emit()
                this.changeAnswerEmit();
            })
            .catch((t) => {
              console.log('Something went wrong', t);
            });
      } else this.alert('请先在答题区定位光标位置');
    },

    pasteMousedownMenu(t) {
      if (this.disabled) return false;
      this._toolBarIconMousedownMenu(t);
      return (this.editorStatus.inToolbar = !0);
    },

    pasteMouseleaveMenu(t) {
      $(t.target).parents('.tool-block').removeClass('ofClicked');
    },

    formulaMousedownMenu(t) {
      if (this.disabled) return false;
      this._toolBarIconMousedownMenu(t);
      if (this.editorStatus)
        return (
          window.$(this).addClass('active'),
          (this.showMenu = !0),
          (this.editorStatus.inToolbar = !0)
        );
    },

    formulaMouseupMenu(t) {
      return window.$(this).removeClass('active');
    },

    formulaMouseenterMenu(t) {
      return (
        window.$(this).addClass('mouseover'),
        this.timerHide && clearTimeout(this.timerHide)
      );
    },

    formulaMouseleaveMenu(t) {
      $(t.target).parents('.tool-block').removeClass('ofClicked');
      if (this.editorStatus)
        return (
          window.$(this).removeClass('mouseover active'),
          (this.editorStatus.inToolbar = !1),
          this.timerHide && clearTimeout(this.timerHide),
          (this.timerHide = setTimeout(() => {
            this.showMenu = !1;
          }, 300))
        );
    },

    tableMousedownMenu(t) {
      if (this.disabled) return false;
      this._toolBarIconMousedownMenu(t);
      if (this.editorStatus)
        return (
          window.$(this).addClass('active'),
          (this.showTabList = !0),
          (this.editorStatus.inToolbar = !0)
        );
    },

    tableMouseupMenu(t) {
      return window.$(this).removeClass('active');
    },

    tableMouseenterMenu(t) {
      return window.$(this).addClass('mouseover');
    },

    tableMouseleaveMenu(t) {
      $(t.target).parents('.tool-block').removeClass('ofClicked');
      if (((this.showTabList = !1), this.editorStatus))
        return (
          window.$(this).removeClass('mouseover active'),
          (this.editorStatus.inToolbar = !1)
        );
    },

    insertFormulaInFormula(t, e) {
      window.MQ.MathField(document.querySelector('#' + e)).write(t),
        this.changeAnswerEmit();
    },

    _bindMqEvent(mq) {
      mq.__controller.container.click(this.handleMqFocus);
      mq.__controller.textarea.blur(this.handleMqBlur);
    },

    _insertLatex(t, e) {
      if (/* e.close(),  */ !this.editorStatus.inEditor)
        return void this.alert('请先在答题区定位光标位置');
      if (this.curFormulaId)
        return void this.insertFormulaInFormula(t.latex, this.curFormulaId);
      //const n = "insert-formula-" + this.examSer.createGuid();
      const n = 'insert-formula-' + new Date().getTime();
      this.insertHtmlAtCursor(t.latex, 'span', n);
      const i = window.MQ.MathField(document.querySelector('#' + n), {
        handlers: {
          edit: function () {},
        },
      });
      this.silentBlur();
      i.clearSelection(), i.focus();
      this._bindMqEvent(i);
      this.changeAnswerEmit(),
        (this.editorStatus.inToolbar = !1),
        (this.editorStatus.inFormula = !0),
        (this.curFormulaId = n);
    },

    insertLatex(t, e) {
      const n = {
        latex: t,
        subData: e,
      };
      this._insertLatex(n),
        (this.showMenu = !1),
        (this.editorStatus.inToolbar = !1);
    },

    customTab(t, e) {
      (this.maxColume = t + 1), (this.maxRow = e + 1);
    },

    creatMatrix(t) {
      //const e = "<div><table id='insert-matrix-" + this.examSer.createGuid() + '\' class=\'matrix matrix-2\' cellpadding="0" cellspacing="0">\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="2" class="title h-50px">\u6a2a\u5750\u6807\u63cf\u8ff0</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="2" class="title h-50px">\u6a2a\u5750\u6807</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td rowspan="2" class="title w-50px h-tb">\u7eb5\u5750\u6807\u63cf\u8ff0</td>\n        <td rowspan="2" class="title w-50px h-tb">\u7eb5\u5750\u6807</td>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n        <td rowspan="2" class="title w-50px h-tb">\u7eb5\u5750\u6807</td>\n        <td rowspan="2" class="title w-50px h-tb">\u7eb5\u5750\u6807\u63cf\u8ff0</td>\n    </tr>\n    <tr>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="2" class="title h-50px">\u6a2a\u5750\u6807</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="2" class="title h-50px">\u6a2a\u5750\u6807\u63cf\u8ff0</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n</table><br></div>'
      //  , n = "<div><table id='insert-matrix-" + this.examSer.createGuid() + '\' class=\'matrix matrix-3\' cellpadding="0" cellspacing="0">\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="3" class="title h-50px">\u6a2a\u5750\u6807\u63cf\u8ff0</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="3" class="title h-50px">\u6a2a\u5750\u6807</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td rowspan="3" class="title w-50px h-tb">\u7eb5\u5750\u6807\u63cf\u8ff0</td>\n        <td rowspan="3" class="title w-50px h-tb">\u7eb5\u5750\u6807</td>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n        <td rowspan="3" class="title w-50px h-tb">\u7eb5\u5750\u6807</td>\n        <td rowspan="3" class="title w-50px h-tb">\u7eb5\u5750\u6807\u63cf\u8ff0</td>\n    </tr>\n    <tr>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n    </tr>\n    <tr>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="3" class="title h-50px">\u6a2a\u5750\u6807</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="3" class="title h-50px">\u6a2a\u5750\u6807\u63cf\u8ff0</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n</table><br></div>';
      const e =
          "<div><table id='insert-matrix-" +
          new Date().getTime() +
          '\' class=\'matrix matrix-2\' cellpadding="0" cellspacing="0">\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="2" class="title h-50px">\u6a2a\u5750\u6807\u63cf\u8ff0</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="2" class="title h-50px">\u6a2a\u5750\u6807</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td rowspan="2" class="title w-50px h-tb">\u7eb5\u5750\u6807\u63cf\u8ff0</td>\n        <td rowspan="2" class="title w-50px h-tb">\u7eb5\u5750\u6807</td>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n        <td rowspan="2" class="title w-50px h-tb">\u7eb5\u5750\u6807</td>\n        <td rowspan="2" class="title w-50px h-tb">\u7eb5\u5750\u6807\u63cf\u8ff0</td>\n    </tr>\n    <tr>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="2" class="title h-50px">\u6a2a\u5750\u6807</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="2" class="title h-50px">\u6a2a\u5750\u6807\u63cf\u8ff0</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n</table><br></div>',
        n =
          "<div><table id='insert-matrix-" +
          new Date().getTime() +
          '\' class=\'matrix matrix-3\' cellpadding="0" cellspacing="0">\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="3" class="title h-50px">\u6a2a\u5750\u6807\u63cf\u8ff0</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="3" class="title h-50px">\u6a2a\u5750\u6807</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td rowspan="3" class="title w-50px h-tb">\u7eb5\u5750\u6807\u63cf\u8ff0</td>\n        <td rowspan="3" class="title w-50px h-tb">\u7eb5\u5750\u6807</td>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n        <td rowspan="3" class="title w-50px h-tb">\u7eb5\u5750\u6807</td>\n        <td rowspan="3" class="title w-50px h-tb">\u7eb5\u5750\u6807\u63cf\u8ff0</td>\n    </tr>\n    <tr>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n    </tr>\n    <tr>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n        <td>&nbsp;</td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="3" class="title h-50px">\u6a2a\u5750\u6807</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n    <tr>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td colspan="3" class="title h-50px">\u6a2a\u5750\u6807\u63cf\u8ff0</td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n        <td class="border-none w-50px h-50px" contenteditable=\'false\'></td>\n    </tr>\n</table><br></div>';
      let i = '';
      return 2 == t ? (i = e) : 3 == t && (i = n), i;
    },

    createTabHtml(t, e) {
      //const n = this.examSer.createGuid();
      const n = new Date().getTime();
      let i = "<div><table id='insert-tab-" + n + "' class='insert-tab'>",
        r = '',
        s = '';
      for (let o = 0; o < t; o++)
        s +=
          "<td data-menu-type = 'table' data-menu-id='" + n + "'>&nbsp;</td>";
      for (let o = 0; o < e; o++) r += '<tr>' + s + '</tr>';
      return (i += r + '</table><br></div>');
    },

    insertTab(t, e) {
      if (/* e.close(),  */ !this.editorStatus.inEditor)
        return void this.alert('请先在答题区定位光标位置');
      if (this.editorStatus.inMatrix || this.editorStatus.inTable)
        //return void this._alertSvc.setValue({
        //    status: !0,
        //    info: {
        //        bodyText: this.translate.instant("items.sa.editor.embedErr3")
        //    }
        //});
        return console.log('items.sa.editor.embedErr3');
      if (this.editorStatus.inFormula)
        return void this.alert('公式不能嵌入表格或矩阵');
      if (this.editorStatus.inMathMatrix)
        //return void this._alertSvc.setValue({
        //    status: !0,
        //    info: {
        //        bodyText: this.translate.instant("items.sa.editor.embedErr2")
        //    }
        //});
        return console.log('items.sa.editor.embedErr2');
      let n = '';
      if ('matrix' === t.type) {
        const { num: e } = t;
        n = this.creatMatrix(e);
      } else {
        const { maxColume: e, maxRow: i } = t;
        n = this.createTabHtml(e, i);
      }
      this.insertHtmlAtCursor(n), this.changeAnswerEmit();
    },

    creatCusMatrix(t) {
      (this.showTabList = !1),
        this.insertTab({
          type: 'matrix',
          num: t,
        }),
        (this.editorStatus.inToolbar = !1);
    },

    creatCusTab() {
      this.showTabList = !1;
      this.insertTab({
        maxColume: this.maxColume,
        maxRow: this.maxRow,
      });
      this.editorStatus.inToolbar = !1;
    },

    getEntityByType() {
      return 'mathMatrix' === this.menuType
        ? window.$('#insert-math-matrix-' + this.curEntityIdDeleted)
        : 'table' === this.menuType
        ? window.$('#insert-tab-' + this.curEntityIdDeleted)
        : void 0;
    },

    getMenuByType() {
      return 'mathMatrix' === this.menuType
        ? document.querySelector('.editor-context-menu.math-matrix-menu')
        : 'table' === this.menuType
        ? document.querySelector('.editor-context-menu.table-menu')
        : void 0;
    },

    getTrInserted(t, e) {
      let n = '<tr>';
      for (let i = 0; i < t; i++)
        n += "<td data-menu-type='table' data-menu-id='" + e + "'>&nbsp;</td>";
      return (n += '</tr>'), n;
    },

    insert(t) {
      const e = this.curEntityIdTd.parent('tr'),
        n = e.children('td').data('menuId'),
        i = this.getTrInserted(e.children('td').length, n);
      this.getTrInserted(e.children('td').length, n);
      switch (t) {
        case 'rowAbove':
          window.$(i).insertBefore(e);
          break;
        case 'rowBelow':
          window.$(i).insertAfter(e);
          break;
        case 'columnLt': {
          const t = this.getEntityByType(),
            e = this.curEntityIdTd.index();
          for (let i = 0; i < t.get(0).rows.length; i++) {
            const r = window.$(t.get(0).rows[i].cells[e]);
            window
              .$(
                "<td data-menu-type='table' data-menu-id='" +
                  n +
                  "'>&nbsp;</td>"
              )
              .insertBefore(r);
          }
          break;
        }
        case 'columnRt': {
          const t = this.getEntityByType(),
            e = this.curEntityIdTd.index();
          for (let i = 0; i < t.get(0).rows.length; i++) {
            const r = window.$(t.get(0).rows[i].cells[e]);
            window
              .$(
                "<td data-menu-type='table' data-menu-id='" +
                  n +
                  "'>&nbsp;</td>"
              )
              .insertAfter(r);
          }
          break;
        }
      }
      this.changeAnswerEmit();
    },

    removeCurEntity() {
      const t = this.getEntityByType();
      t && t.remove(),
        //this.updateItemResponse()
        this.changeAnswerEmit();
    },

    removeCurRow() {
      const t = this.curEntityIdTd.parent('tr'),
        e = this.getEntityByType();
      if (1 === e.find('tr').length)
        return (
          e.remove(),
          //void this.updateItemResponse();
          this.changeAnswerEmit()
        );
      t.remove(),
        1 === e.find('tr').length && e.addClass('one-row'),
        //this.updateItemResponse()
        this.changeAnswerEmit();
    },

    removeCurColume() {
      const t = this.getEntityByType(),
        e = this.curEntityIdTd.index();
      if (1 === t.find('tr').eq(0).children('td').length)
        return (
          t.remove(),
          //void this.updateItemResponse();
          this.changeAnswerEmit()
        );
      for (let n = 0; n < t.get(0).rows.length; n++)
        t.get(0).rows[n].deleteCell(e);
      1 === t.find('tr').eq(0).children('td').length &&
        t.addClass('one-colume'),
        //this.updateItemResponse()
        this.changeAnswerEmit();
    },

    _getEventMq(e) {
      const $el = $(e.target);
      const $mqEditableField = $el.hasClass('mq-editable-field')
        ? $el
        : $el.parents('.mq-editable-field');
      return window.MQ($mqEditableField[0]);
    },

    _mqUpdateLatex(mq) {
      mq.el().setAttribute('latex', mq.latex());
    },

    _mqFocus(e) {
      this._getEventMq(e).focus();
    },

    handleMqFocus(e) {
      setTimeout(() => {
        this._mqFocus(e);
      }, 0);
    },

    handleMqBlur(e) {
      const mq = this._getEventMq(e);
      this._mqUpdateLatex(mq);
      this.changeAnswerEmit();
      setTimeout(() => {
        if (this.isToolBarIconClicked) {
          this._mqFocus(e);
          this.isToolBarIconClicked = false;
        }
      }, 0);
    },

    handleBlur() {
      setTimeout(() => {
        if (this.flagBlur) {
          if (this.isToolBarIconClicked) {
            this.focus();
            this.isToolBarIconClicked = false;
          }
        }
        this.flagBlur = true;
      }, 0);
    },

    focus() {
      this.$refs.answerArea.focus();
    },

    silentBlur() {
      this.flagBlur = false;
      this.$refs.answerArea.blur();
    },

    changeAnswerEmit() {
      const answerAreaHtml = this.$refs.answerArea.innerHTML
        .replace(/ mathquill-(?:command|block)-id="?\d+"?/g, '')
        .replace(/<span class="?mq-cursor( mq-blink)?"?>.?<\/span>/gi, '')
        .replace(/ mq-focused| mq-hasCursor|mq-hasCursor ?/g, '')
        .replace(/ class=(""|(?= |>))/g, '');
      this.prevValue = answerAreaHtml;
      this.$emit('input', answerAreaHtml);
    },

    setAnswerAreaHtml() {
      this.prevValue = this.value;
      this.$refs.answerArea.innerHTML = this.value;
      if (!this.disabled) {
        setTimeout(() => {
          const $mqEditableField = $(this.$refs.answerArea).find(
            '.mq-editable-field'
          );
          if ($mqEditableField.length) {
            for (let i = 0; i < $mqEditableField.length; i++) {
              $($mqEditableField[i]).html('');
              const mq = window.MQ.MathField($mqEditableField[i]);
              mq.latex(mq.el().getAttribute('latex'));
              this._bindMqEvent(mq);
            }
          }
        }, 0);
      }
    },

    alert(strAlert) {
      Swal.fire({
        title: strAlert,
        type: 'warning',
        confirmButtonText: '确定',
      });
    },
  },

  created() {
    this.resetToolVal();
    window.addEventListener('resize', this.setAnswerHg);
    window.addEventListener('click', this.hideContextMenu);
  },

  mounted() {
    this.$refs.item.addEventListener('focus', this.itemContDomFocused, !0);
    this.$refs.item.addEventListener('blur', this.itemContDomBlur, !0);
    this.$refs.item.addEventListener('contextmenu', this.initContextmenu);
    this.$refs.answerArea.addEventListener('paste', function (t) {
      t.preventDefault();
      const e = (t.originalEvent || t).clipboardData.getData('text/plain');
      document.execCommand('insertHTML', !1, e);
    });
    this.setAnswerAreaHtml();
  },

  beforeDestroy() {
    this.$refs.item.removeEventListener('focus', this.itemContDomFocused);
    this.$refs.item.removeEventListener('blur', this.itemContDomBlur);
    this.$refs.item.removeEventListener('contextmenu', this.initContextmenu);
    window.removeEventListener('resize', this.setAnswerHg);
    window.removeEventListener('click', this.hideContextMenu);
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a,
audio,
button,
input,
textarea {
  outline: 0;
}
a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}

ol ol,
ol ul,
ul ol,
ul ul {
  margin-bottom: 0;
}
dl,
ol,
ul {
  margin-top: 0;
}
address,
dl,
ol,
ul {
  margin-bottom: 1rem;
}
ul,
ul li {
  margin: 0;
  padding: 0;
  list-style: none;
}
small {
  font-size: 80%;
}
.small,
small {
  font-size: 80%;
  font-weight: 400;
}
.d-inline-block {
  display: inline-block !important;
}
.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}
.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}
.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}
.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}
/* @font-face {
  font-family: iconfont;
  src: url(iconfont.eot);
  src: url(iconfont.eot?#iefix) format('embedded-opentype'),
    url(/css/saeditor/font/iconfont.woff) format('woff'),
    url(iconfont.ttf) format('truetype'),
    url(iconfont.svg#iconfont) format('svg');
} */
@font-face {
  font-family: iconfont;
  src: url(/css/saeditor/font/iconfont.woff) format('woff');
}
.iconfont {
  font-family: iconfont !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
.wrap-tool-bar {
  background: #f0f0f0;
  padding: 3px 8px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid #ddd;
  border-bottom: none;
  position: relative;
}
.wrap-tool-bar .tool-bar > .tool-block {
  display: inline-block;
  width: 30px;
  border: 1px solid transparent;
  text-align: center;
  line-height: 30px;
}
.wrap-tool-bar .tool-bar > .tool-block:hover {
  background-color: #ddd;
  border: 1px solid #ccc;
}
.wrap-tool-bar li {
  cursor: pointer;
}
.wrap-tool-bar .tool-bar > .tool-block i.iconfont {
  font-size: 18px;
}
li .wra-nav-tabs {
  position: absolute;
  left: -30px;
  top: 31px;
  width: 300px;
  background: #fff;
  z-index: 1;
  border: 1px solid #ddd;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
}
.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
li .wra-nav-tabs .nav-tabs > li {
  width: 33.33%;
}
.wrap-tool-bar li {
  cursor: pointer;
}
.nav-tabs .nav-item {
  margin-bottom: -1px;
}
li .nav-link.active {
  color: #447dff;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
li .nav-link {
  padding: 0.05rem 1rem;
  color: #666;
}
.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
li.tool-formula {
  position: relative;
  width: 100%;
}
.formular-list li {
  display: inline-block;
  padding: 0;
  margin: 0 6px 6px 0;
  list-style: none;
  background-image: url(/img/function.gif);
  background-repeat: no-repeat;
  border: 1px solid transparent;
  border-radius: 2px;
  width: 30px;
  height: 30px;
}
.formular-list li:hover {
  border-color: #447dff;
}
.formular-list li.fa1 {
  background-position: 0 0;
}
.formular-list li.fa2 {
  background-position: -34px 0;
}
.formular-list li.fa3 {
  background-position: -68px 0;
}
.formular-list li.fa4 {
  background-position: -102px 0;
}
.formular-list li.fa5 {
  background-position: -136px 0;
}
.formular-list li.fa6 {
  background-position: -170px 0;
}
.formular-list li.fa7 {
  background-position: -204px 0;
}
.formular-list li.fa8 {
  background-position: -238px 0;
}
.formular-list li.fa9 {
  background-position: -272px 0;
}
.formular-list li.fa10 {
  background-position: 0 -34px;
}
.formular-list li.fa11 {
  background-position: -34px -34px;
}
.formular-list li.fa12 {
  background-position: -68px -34px;
}
.formular-list li.fa13 {
  background-position: -102px -34px;
}
.formular-list li.fa14 {
  background-position: -136px -34px;
}
.formular-list li.fa15 {
  background-position: -170px -34px;
}
.formular-list li.fa16 {
  background-position: -204px -34px;
}
.formular-list li.fa17 {
  background-position: -238px -34px;
}
.formular-list li.fa18 {
  background-position: -272px -34px;
}
.formular-list li.fa19 {
  background-position: -306px 0;
}
.formular-list li.fa20 {
  background-position: -306px -34px;
}
.formular-list li.fb1 {
  background-position: 0 -68px;
}
.formular-list li.fb2 {
  background-position: -34px -68px;
}
.formular-list li.fb3 {
  background-position: -68px -68px;
}
.formular-list li.fb4 {
  background-position: -102px -68px;
}
.formular-list li.fb5 {
  background-position: -136px -68px;
}
.formular-list li.fb6 {
  background-position: -170px -68px;
}
.formular-list li.fb7 {
  background-position: -204px -68px;
}
.formular-list li.fb8 {
  background-position: -238px -68px;
}
.formular-list li.fb9 {
  background-position: -272px -68px;
}
.formular-list li.fb10 {
  background-position: 0 -102px;
}
.formular-list li.fb11 {
  background-position: -34px -102px;
}
.formular-list li.fb12 {
  background-position: -68px -102px;
}
.formular-list li.fb13 {
  background-position: -102px -102px;
}
.formular-list li.fb14 {
  background-position: -136px -102px;
}
.formular-list li.fb15 {
  background-position: -170px -102px;
}
.formular-list li.fb16 {
  background-position: -204px -102px;
}
.formular-list li.fc1 {
  background-position: 0 -136px;
}
.formular-list li.fc2 {
  background-position: -34px -136px;
}
.formular-list li.fc3 {
  background-position: -68px -136px;
}
.formular-list li.fc4 {
  background-position: -102px -136px;
}
.formular-list li.fc5 {
  background-position: -136px -136px;
}
.formular-list li.fc6 {
  background-position: -170px -136px;
}
.formular-list li.fc7 {
  background-position: -204px -136px;
}
.formular-list li.fc8 {
  background-position: -238px -136px;
}
.formular-list li.fc9 {
  background-position: -272px -136px;
}
.formular-list li.fc10 {
  background-position: 0 -170px;
}
.formular-list li.fc11 {
  background-position: -34px -170px;
}
.formular-list li.fc12 {
  background-position: -68px -170px;
}
.formular-list li.fc13 {
  background-position: -102px -170px;
}
.wrap-tab-li {
  position: relative;
  width: 100%;
}
.wrap-tab-li .wrap-tab-cont {
  position: absolute;
  left: -30px;
  width: 190px;
  top: 31px;
  background: #fff;
  z-index: 9;
  padding: 5px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
}
.wrap-tab-li .tab-list li {
  float: left;
}
.wrap-tab-li .tab-list span {
  /* display: inline-block; */
  float: left;
  width: 15px;
  height: 15px;
  border: 1px solid #ddd;
  border-right: none;
  border-bottom: none;
}
.wrap-tab-li .tab-list span.active {
  background-color: #ddd;
  border: 1px solid #ccc;
  border-right: none;
  border-bottom: none;
}
.answer-area {
  border: 1px solid #ddd;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 5px;
  outline: none;
  overflow: auto;
  background-color: #fafafa;
}
.answer-area.without-answer {
  min-height: 210px;
}
.answer-area:focus {
  border: 1px solid #8cc6fd;
  background-color: #fff;
}
ul.editor-context-menu {
  cursor: pointer;
  position: fixed;
  display: none;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
ul.editor-context-menu li {
  padding: 3px 10px;
}
ul.editor-context-menu li:hover {
  background-color: #e1e1e1;
}
ul.editor-context-menu li .arrow-rt {
  font-size: 12px;
  line-height: 22px;
}
ul.editor-context-menu .sub-table-menu {
  position: absolute;
  left: 117px;
  width: 150px;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.1);
  background: #fff;
  top: 0;
  text-align: center;
  color: #000;
}
ul.editor-context-menu .sub-table-menu.sub-menu-insert {
  display: none;
}
ul.editor-context-menu li:hover .sub-menu-insert {
  display: block;
}
.tool-block {
  position: relative;
}
.tool-block::before,
.tool-block::after {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.2s ease-out;
  position: absolute;
  z-index: 99;
}
.tool-block::before {
  content: '';
  border-color: transparent;
  border-style: solid;
  left: calc(100% + 0.2rem);
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
  width: 0.4rem;
  height: 0.8rem;
  top: calc(50% - 0.4rem);
}
.tool-block::after {
  max-width: 200px;
  min-width: 22px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
  content: attr(data-title);
  top: 0;
  left: calc(100% + 0.6rem);
}
.tool-block:hover::before,
.tool-block:hover::after {
  visibility: visible;
  opacity: 1;
  word-break: keep-all;
}
.tool-block.ofClicked::before,
.tool-block.ofClicked::after {
  visibility: hidden;
  opacity: 0;
}
</style>
<style>
.mq-editable-field.mq-focused,
.mq-math-mode .mq-editable-field.mq-focused {
  -webkit-box-shadow: #8bd 0 0 1px 2px, inset #6ae 0 0 2px 0;
  -moz-box-shadow: #8bd 0 0 1px 2px, inset #6ae 0 0 2px 0;
  box-shadow: #8bd 0 0 1px 2px, inset #6ae 0 0 2px 0;
  border-color: #709ac0;
  border-radius: 1px;
}
table.insert-tab {
  width: 90%;
  border: 1px solid;
  margin: 3px;
  border-collapse: collapse;
}
table.insert-tab > tbody > tr > td {
  border: 1px solid;
  min-width: 100px;
}
.item table td,
.item table th {
  border: none;
}
.item table td,
.item table th {
  border: 1px solid;
}
table.matrix {
  border-collapse: collapse;
  border: none;
}
table.matrix tr td {
  border: 1px solid;
  width: 200px;
  height: 80px;
}
table.matrix tr td.h-50px {
  height: 30px;
  text-align: center;
}
table.matrix tr td.w-50px {
  width: 30px;
  text-align: center;
}
table.matrix tr td.border-none {
  border: none;
}
table.matrix tr td.title {
  color: #999;
  border-color: #000;
}
table.matrix tr td.title:hover {
  color: #000;
}
table.matrix tr td.h-tb {
  writing-mode: vertical-lr;
  -webkit-writing-mode: vertical-lr;
  -ms-writing-mode: vertical-lr;
}
</style>
